module.exports = __webpack_public_path__ + "static/media/howitworks1.3e883509.webp";